var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-modal",
    {
      attrs: {
        "class-name": "m-issue-inventory-item",
        active: _vm.active,
        "hide-header": "",
        "disable-scroll": _vm.disableScroll,
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c("c-button", {
                staticClass: "issue-item__cancel",
                attrs: { label: "Отменить" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                staticClass: "issue-item__submit",
                attrs: {
                  color: "primary",
                  label: "Выдать",
                  pending: _vm.pending,
                },
                on: { click: _vm.submit },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "issue-item" }, [
        _c("div", { staticClass: "modal-frame__header" }, [
          _c("h2", { staticClass: "modal-frame__title" }, [
            _vm._v(" Выдать ТМЦ "),
            _c("span", { staticClass: "font-weight-normal" }, [
              _vm._v("№" + _vm._s(_vm.item && _vm.item.serialNumber)),
            ]),
            _vm.item && _vm.item.name
              ? _c("div", { staticClass: "item-name" }, [
                  _vm._v(_vm._s(_vm.item.name)),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "issue-item-form" }, [
          _c("div", { staticClass: "d-flex flex-wrap" }, [
            _c(
              "div",
              {
                staticClass: "form-group issue-item-form__date",
                class: {
                  "form-group--invalid": _vm.isSubmitted && _vm.dateError,
                },
              },
              [
                _c("c-input", {
                  ref: "calendar",
                  attrs: {
                    label: "Дата выдачи",
                    type: "date",
                    "required-mark": true,
                    clearable: true,
                    required: _vm.isSubmitted && _vm.dateError,
                    "required-error": _vm.isSubmitted && _vm.dateError,
                    format: "DD.MM.YYYY, dddd",
                    editable: true,
                    icon: "calendar",
                    placeholder: "00.00.0000",
                    "icon-right": true,
                  },
                  model: {
                    value: _vm.form.date,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "date", $$v)
                    },
                    expression: "form.date",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-group issue-item-form__actor" },
              [
                _c("c-input", {
                  attrs: {
                    type: "select",
                    "floating-label": "Кто выдает",
                    searchable: true,
                    clearable: true,
                    items: _vm.actors,
                  },
                  model: {
                    value: _vm.form.actor,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "actor", $$v)
                    },
                    expression: "form.actor",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "form-group issue-item-form__worker",
              class: {
                "form-group--invalid": _vm.isSubmitted && _vm.workerError,
              },
            },
            [
              _c("c-input", {
                attrs: {
                  type: "select",
                  "floating-label": "Кому выдается",
                  searchable: true,
                  clearable: true,
                  items: _vm.workers,
                  "required-mark": true,
                  required: _vm.isSubmitted && _vm.workerError,
                  "required-condition": _vm.isSubmitted && _vm.workerError,
                },
                model: {
                  value: _vm.form.worker,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "worker", $$v)
                  },
                  expression: "form.worker",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-group inventory-item-form__comment" },
            [
              _c("c-textarea", {
                attrs: {
                  type: "textarea",
                  clearable: true,
                  "floating-label": "Комментарий",
                  "max-length": "500",
                },
                model: {
                  value: _vm.form.comment,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "comment", $$v)
                  },
                  expression: "form.comment",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-group inventory-item-form__loader" },
            [
              _c("file-loader", {
                ref: "loader",
                attrs: { format: "all", limit: 10 },
                model: {
                  value: _vm.files,
                  callback: function ($$v) {
                    _vm.files = $$v
                  },
                  expression: "files",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }